
export const gameShowData = [
  {
    gameId: 'JIL-chickendash',
    name: 'Chicken Dash',
    tableId: 'JIL',
    category: 'CASINO/INSTANTWIN/MINES',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=JIL-chickendash_en_US&type=logo-square&version=1758692708003',
  },
  {
    gameId: 'IDS-1millionfortunesmegaways',
    name: '1 Million Fortunes Megaways',
    tableId: 'IDS',
    category: 'CASINO/SLOT/7REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-1millionfortunesmegaways_en_US&type=logo-square&version=1662574283854',
  },
  {
    gameId: 'EVO-dealnodeal',
    name: 'Deal or No Deal',
    tableId: 'EVO',
    category: 'CASINO/GAME_SHOW',
    demoSupport: false,
    img: 'https://client.qtlauncher.com/images/?id=EVO-dealnodeal_en_US&type=logo-square&version=1678378487577',
  },
  {
    gameId: 'IDS-onemillionmegawaysbc',
    name: '1 Million Megaways BC',
    tableId: 'IDS',
    category: 'CASINO/SLOT/6REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-onemillionmegawaysbc_en_US&type=logo-square&version=1683023980854',
  },
  {
    gameId: 'IDS-3crazytikis',
    name: '3 Crazy Tikis',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3crazytikis_en_US&type=logo-square&version=1726489271108',
  },
  {
    gameId: 'IDS-3hotchillipeppers',
    name: '3 Hot Chilli Peppers',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3hotchillipeppers_en_US&type=logo-square&version=1743583339537',
  },
  {
    gameId: 'IDS-3leprechauncharms',
    name: '3 Leprechaun Charms',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3leprechauncharms_en_US&type=logo-square&version=1741161318996',
  },
  {
    gameId: 'IDS-3pluckyhens',
    name: '3 Plucky Hens',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3pluckyhens_en_US&type=logo-square&version=1740554190654',
  },
  {
    gameId: 'IDS-3porkybankshnw',
    name: '3 Porky Banks Hold & Win',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3porkybankshnw_en_US&type=logo-square&version=1722338408095',
  },
  {
    gameId: 'IDS-3porkybankschristmasedition',
    name: '3 Porky Banks: Christmas Edition',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3porkybankschristmasedition_en_US&type=logo-square&version=1733319497662',
  },
  {
    gameId: 'IDS-3dbaccarat',
    name: '3D Baccarat',
    tableId: 'IDS',
    category: 'CASINO/TABLEGAME/BACCARAT',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3dbaccarat_en_US&type=logo-square&version=1678732199305',
  },
  {
    gameId: 'IDS-3droulette',
    name: '3D Roulette',
    tableId: 'IDS',
    category: 'CASINO/TABLEGAME/ROULETTE',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3droulette_en_US&type=logo-square&version=1678732444607',
  },
  {
    gameId: 'IDS-8treasuresluckofthedragon',
    name: '8 Treasures: Luck of the dragon',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-8treasuresluckofthedragon_en_US&type=logo-square&version=1706614628068',
  },
  {
    gameId: 'IDS-apexstrikeluckycache',
    name: 'Apex Strike Lucky Cache',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-apexstrikeluckycache_en_US&type=logo-square&version=1732627963112',
  },
  {
    gameId: 'IDS-apexstrikemegaways',
    name: 'Apex Strike Megaways',
    tableId: 'IDS',
    category: 'CASINO/SLOT/6REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-apexstrikemegaways_en_US&type=logo-square&version=1706100249054',
  },
  {
    gameId: 'IDS-arribaheatsalsawilds',
    name: 'Arriba Heat: Salsa Wilds',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-arribaheatsalsawilds_en_US&type=logo-square&version=1713865813072',
  },
  {
    gameId: 'IDS-astronewtsmegaways',
    name: 'Astro Newts Megaways',
    tableId: 'IDS',
    category: 'CASINO/SLOT/6REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-astronewtsmegaways_en_US&type=logo-square&version=1678732495320',
  },
]

export const gameShowDataGap = [
  {
    gameId: 'JIL-chickendash',
    name: 'Chicken Dash',
    tableId: 'JIL',
    category: 'CASINO/INSTANTWIN/MINES',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=JIL-chickendash_en_US&type=logo-square&version=1758692708003',
    redirect: '/gap-casino/600217/casino/JiLi',
  },
  {
    gameId: 'IDS-1millionfortunesmegaways',
    name: '1 Million Fortunes Megaways',
    tableId: 'IDS',
    category: 'CASINO/SLOT/7REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-1millionfortunesmegaways_en_US&type=logo-square&version=1662574283854',
    redirect: '/gap-casino/201036/Slot games/DC',
  },
  {
    gameId: 'EVO-dealnodeal',
    name: 'Deal or No Deal',
    tableId: 'EVO',
    category: 'CASINO/GAME_SHOW',
    demoSupport: false,
    img: 'https://client.qtlauncher.com/images/?id=EVO-dealnodeal_en_US&type=logo-square&version=1678378487577',
    redirect: '/gap-casino/240323/Others/DC',
  },
  {
    gameId: 'IDS-onemillionmegawaysbc',
    name: '1 Million Megaways BC',
    tableId: 'IDS',
    category: 'CASINO/SLOT/6REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-onemillionmegawaysbc_en_US&type=logo-square&version=1683023980854',
    redirect: '/gap-casino/201036/Slot games/DC',
  },
  {
    gameId: 'IDS-3crazytikis',
    name: '3 Crazy Tikis',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3crazytikis_en_US&type=logo-square&version=1726489271108',
    redirect: '/gap-casino/203585/Live Game Shows/DC',
  },
  {
    gameId: 'IDS-3hotchillipeppers',
    name: '3 Hot Chilli Peppers',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3hotchillipeppers_en_US&type=logo-square&version=1743583339537',
    redirect: '/gap-casino/600019/Slot games/JiLi',
  },
  {
    gameId: 'IDS-3leprechauncharms',
    name: '3 Leprechaun Charms',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3leprechauncharms_en_US&type=logo-square&version=1741161318996',
    redirect: '/gap-casino/200365/Slot Games/DC',
  },
  {
    gameId: 'IDS-3pluckyhens',
    name: '3 Plucky Hens',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3pluckyhens_en_US&type=logo-square&version=1740554190654',
    redirect: '/gap-casino/200311/Slot Games/DC',
  },
  {
    gameId: 'IDS-3porkybankshnw',
    name: '3 Porky Banks Hold & Win',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3porkybankshnw_en_US&type=logo-square&version=1722338408095',
    redirect: '/gap-casino/230907/Video Slots/DC',
  },
  {
    gameId: 'IDS-3porkybankschristmasedition',
    name: '3 Porky Banks: Christmas Edition',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3porkybankschristmasedition_en_US&type=logo-square&version=1733319497662',
    redirect: '/gap-casino/201776/Slot Games/DC',
  },
  {
    gameId: 'IDS-3dbaccarat',
    name: '3D Baccarat',
    tableId: 'IDS',
    category: 'CASINO/TABLEGAME/BACCARAT',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3dbaccarat_en_US&type=logo-square&version=1678732199305',
    redirect: '/gap-casino/201162/Slot Games/DC',
  },
  {
    gameId: 'IDS-3droulette',
    name: '3D Roulette',
    tableId: 'IDS',
    category: 'CASINO/TABLEGAME/ROULETTE',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-3droulette_en_US&type=logo-square&version=1678732444607',
    redirect: '/gap-casino/241131/Bingo/DC',
  },
  {
    gameId: 'IDS-8treasuresluckofthedragon',
    name: '8 Treasures: Luck of the dragon',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-8treasuresluckofthedragon_en_US&type=logo-square&version=1706614628068',
    redirect: '/gap-casino/350352/Slot/BETCORE',
  },
  {
    gameId: 'IDS-apexstrikeluckycache',
    name: 'Apex Strike Lucky Cache',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-apexstrikeluckycache_en_US&type=logo-square&version=1732627963112',
    redirect: '/gap-casino/242846/Video Slots/DC',
  },
  {
    gameId: 'IDS-apexstrikemegaways',
    name: 'Apex Strike Megaways',
    tableId: 'IDS',
    category: 'CASINO/SLOT/6REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-apexstrikemegaways_en_US&type=logo-square&version=1706100249054',
    redirect: '/gap-casino/242854/Video Slots/DC',
  },
  {
    gameId: 'IDS-arribaheatsalsawilds',
    name: 'Arriba Heat: Salsa Wilds',
    tableId: 'IDS',
    category: 'CASINO/SLOT/5REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-arribaheatsalsawilds_en_US&type=logo-square&version=1713865813072',
    redirect: '/gap-casino/400732/SLOT/AWC',
  },
  {
    gameId: 'IDS-astronewtsmegaways',
    name: 'Astro Newts Megaways',
    tableId: 'IDS',
    category: 'CASINO/SLOT/6REEL',
    demoSupport: true,
    img: 'https://client.qtlauncher.com/images/?id=IDS-astronewtsmegaways_en_US&type=logo-square&version=1678732495320',
    redirect: '/gap-casino/201278/Slot Games/DC',
  },
]
